"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var KurtosysLogo_svg_1 = __importDefault(require("../../assets/images/KurtosysLogo.svg"));

var DropdownChevronIcon_svg_1 = __importDefault(require("../../assets/images/DropdownChevronIcon.svg"));

var DropdownChevronIconExpanded_svg_1 = __importDefault(require("../../assets/images/DropdownChevronIconExpanded.svg"));

var Calendar_svg_1 = __importDefault(require("../../assets/images/Calendar.svg"));

var CalendarPlaceholder_svg_1 = __importDefault(require("../../assets/images/CalendarPlaceholder.svg"));

var CarouselNavArrowLeftIcon_svg_1 = __importDefault(require("../../assets/images/CarouselNavArrowLeftIcon.svg"));

var CarouselNavArrowRightIcon_svg_1 = __importDefault(require("../../assets/images/CarouselNavArrowRightIcon.svg"));

var CheckboxIcon_svg_1 = __importDefault(require("../../assets/images/CheckboxIcon.svg"));

var CheckboxMarkedIcon_svg_1 = __importDefault(require("../../assets/images/CheckboxMarkedIcon.svg"));

var CheckboxHalfIcon_svg_1 = __importDefault(require("../../assets/images/CheckboxHalfIcon.svg"));

var DownloadIcon_svg_1 = __importDefault(require("../../assets/images/DownloadIcon.svg"));

var DocumentLabelIcon_svg_1 = __importDefault(require("../../assets/images/DocumentLabelIcon.svg"));

var InformationIcon_svg_1 = __importDefault(require("../../assets/images/InformationIcon.svg"));

var MagnificationGlass_svg_1 = __importDefault(require("../../assets/images/MagnificationGlass.svg"));

var Spinner_svg_1 = __importDefault(require("../../assets/images/Spinner.svg"));

var CaretUp_svg_1 = __importDefault(require("../../assets/images/CaretUp.svg"));

var CaretDown_svg_1 = __importDefault(require("../../assets/images/CaretDown.svg"));

var AccordionExpandIcon_svg_1 = __importDefault(require("../../assets/images/AccordionExpandIcon.svg"));

var AccordionCollapseIcon_svg_1 = __importDefault(require("../../assets/images/AccordionCollapseIcon.svg"));

var Cross_svg_1 = __importDefault(require("../../assets/images/Cross.svg"));

var Close_svg_1 = __importDefault(require("../../assets/images/Close.svg"));

var HomeIcon_svg_1 = __importDefault(require("../../assets/images/HomeIcon.svg"));

var SelectedResultClear_svg_1 = __importDefault(require("../../assets/images/SelectedResultClear.svg"));

var PersonOutlineIcon_svg_1 = __importDefault(require("../../assets/images/PersonOutlineIcon.svg"));

var MessageIcon_svg_1 = __importDefault(require("../../assets/images/MessageIcon.svg"));

var FingerPrintIcon_svg_1 = __importDefault(require("../../assets/images/FingerPrintIcon.svg"));

var BackArrowIcon_svg_1 = __importDefault(require("../../assets/images/BackArrowIcon.svg"));

var ShieldIcon_svg_1 = __importDefault(require("../../assets/images/ShieldIcon.svg"));

var RefreshIcon_svg_1 = __importDefault(require("../../assets/images/RefreshIcon.svg"));

var PagingLeftArrow_svg_1 = __importDefault(require("../../assets/images/PagingLeftArrow.svg"));

var PagingRightArrow_svg_1 = __importDefault(require("../../assets/images/PagingRightArrow.svg"));

var PagingLeftArrowDisabled_svg_1 = __importDefault(require("../../assets/images/PagingLeftArrowDisabled.svg"));

var PagingRightArrowDisabled_svg_1 = __importDefault(require("../../assets/images/PagingRightArrowDisabled.svg"));

var PreviousMonth_svg_1 = __importDefault(require("../../assets/images/PreviousMonth.svg"));

var NextMonth_svg_1 = __importDefault(require("../../assets/images/NextMonth.svg"));

var ToggleActive_svg_1 = __importDefault(require("../../assets/images/ToggleActive.svg"));

var ToggleInactive_svg_1 = __importDefault(require("../../assets/images/ToggleInactive.svg"));

var ToggleLoading_svg_1 = __importDefault(require("../../assets/images/ToggleLoading.svg"));

var SortAscending_svg_1 = __importDefault(require("../../assets/images/SortAscending.svg"));

var SortDescending_svg_1 = __importDefault(require("../../assets/images/SortDescending.svg"));

var SortUnset_svg_1 = __importDefault(require("../../assets/images/SortUnset.svg"));

var SortLoading_svg_1 = __importDefault(require("../../assets/images/SortLoading.svg"));

var SavedSearchSave_svg_1 = __importDefault(require("../../assets/images/SavedSearchSave.svg"));

var SavedSearchToggleOpen_svg_1 = __importDefault(require("../../assets/images/SavedSearchToggleOpen.svg"));

var SavedSearchToggleClosed_svg_1 = __importDefault(require("../../assets/images/SavedSearchToggleClosed.svg"));

var SavedSearchList_svg_1 = __importDefault(require("../../assets/images/SavedSearchList.svg"));

var DeleteSavedSearch_svg_1 = __importDefault(require("../../assets/images/DeleteSavedSearch.svg"));

var SavedSearchNotificationOff_svg_1 = __importDefault(require("../../assets/images/SavedSearchNotificationOff.svg"));

var SavedSearchNotificationOn_svg_1 = __importDefault(require("../../assets/images/SavedSearchNotificationOn.svg"));

var StarEmpty_svg_1 = __importDefault(require("../../assets/images/StarEmpty.svg"));

var StarFilledDefault_svg_1 = __importDefault(require("../../assets/images/StarFilledDefault.svg"));

var StarFilledPoor_svg_1 = __importDefault(require("../../assets/images/StarFilledPoor.svg"));

var StarFilledModerate_svg_1 = __importDefault(require("../../assets/images/StarFilledModerate.svg"));

var StarFilledGood_svg_1 = __importDefault(require("../../assets/images/StarFilledGood.svg"));

var StarFilledOutstanding_svg_1 = __importDefault(require("../../assets/images/StarFilledOutstanding.svg"));
/* [AddAsset: import] */


exports.baseAssets = {
  icons: {
    download: DownloadIcon_svg_1.default,
    spinner: Spinner_svg_1.default,
    backArrow: BackArrowIcon_svg_1.default,
    message: MessageIcon_svg_1.default
  },
  image: {
    logo: KurtosysLogo_svg_1.default
  },
  contextMenu: {
    dropdownIcon: DropdownChevronIcon_svg_1.default,
    dropdownIconExpanded: DropdownChevronIconExpanded_svg_1.default
  },
  calendarInput: {
    calendar: Calendar_svg_1.default,
    previousMonth: PreviousMonth_svg_1.default,
    nextMonth: NextMonth_svg_1.default
  },
  carousel: {
    navLeft: CarouselNavArrowLeftIcon_svg_1.default,
    navRight: CarouselNavArrowRightIcon_svg_1.default
  },
  checkbox: {
    checked: CheckboxMarkedIcon_svg_1.default,
    unchecked: CheckboxIcon_svg_1.default,
    half: CheckboxHalfIcon_svg_1.default
  },
  dateRangeInput: {
    clearField: Close_svg_1.default
  },
  documentDownload: {
    icon: DownloadIcon_svg_1.default,
    spinner: Spinner_svg_1.default,
    documentLabelIcon: DocumentLabelIcon_svg_1.default
  },
  dialog: {
    close: Close_svg_1.default
  },
  search: {
    cross: Cross_svg_1.default,
    magnificationGlass: MagnificationGlass_svg_1.default,
    spinner: Spinner_svg_1.default,
    selectedResultClear: SelectedResultClear_svg_1.default
  },
  savedSearch: {
    save: SavedSearchSave_svg_1.default,
    list: SavedSearchList_svg_1.default,
    toggleOpen: SavedSearchToggleOpen_svg_1.default,
    toggleClosed: SavedSearchToggleClosed_svg_1.default
  },
  savedSearchList: {
    delete: DeleteSavedSearch_svg_1.default,
    notificationOff: SavedSearchNotificationOff_svg_1.default,
    notificationOn: SavedSearchNotificationOn_svg_1.default
  },
  tooltip: {
    defaultIcon: InformationIcon_svg_1.default
  },
  dropdown: {
    caretUp: CaretUp_svg_1.default,
    caretDown: CaretDown_svg_1.default
  },
  accordionPanel: {
    expandIcon: AccordionExpandIcon_svg_1.default,
    collapseIcon: AccordionCollapseIcon_svg_1.default
  },
  iconInput: {
    home: HomeIcon_svg_1.default,
    personOutline: PersonOutlineIcon_svg_1.default,
    message: MessageIcon_svg_1.default,
    fingerPrint: FingerPrintIcon_svg_1.default,
    shield: ShieldIcon_svg_1.default
  },
  imagePicker: {
    toggleDown: CaretDown_svg_1.default,
    toggleUp: CaretUp_svg_1.default,
    refresh: RefreshIcon_svg_1.default
  },
  loadingIndicator: {
    spinner: Spinner_svg_1.default
  },
  paging: {
    leftArrow: PagingLeftArrow_svg_1.default,
    rightArrow: PagingRightArrow_svg_1.default,
    leftArrowDisabled: PagingLeftArrowDisabled_svg_1.default,
    rightArrowDisabled: PagingRightArrowDisabled_svg_1.default
  },
  toast: {
    close: Close_svg_1.default
  },
  dateDropdown: {
    calendar: Calendar_svg_1.default,
    calendarPlaceholder: CalendarPlaceholder_svg_1.default
  },
  toggleButton: {
    inactive: ToggleInactive_svg_1.default,
    active: ToggleActive_svg_1.default,
    loading: ToggleLoading_svg_1.default
  },
  sortButton: {
    ascending: SortAscending_svg_1.default,
    descending: SortDescending_svg_1.default,
    loading: SortLoading_svg_1.default,
    unset: SortUnset_svg_1.default
  },
  scale: {
    empty: StarEmpty_svg_1.default,
    filledDefault: StarFilledDefault_svg_1.default,
    overrides: [{
      value: 1,
      asset: StarFilledPoor_svg_1.default
    }, {
      value: 2,
      asset: StarFilledModerate_svg_1.default
    }, {
      value: 3,
      asset: StarFilledGood_svg_1.default
    }, {
      value: 4,
      asset: StarFilledOutstanding_svg_1.default
    }]
  }
};